import Step5 from './Step5'

export default Step5
